class Jornaya {
  static instance = null;

  static getInstance() {
    if (!Jornaya.instance) {
      Jornaya.instance = new Jornaya();
    }

    return Jornaya.instance;
  }

  constructor() {
    this.leadidToken = '';
    if (typeof window.LeadiD !== 'undefined') {
      return this;
    }

    if (
      !process.env.VUE_APP_JORNAYA_ACCOUNT_CODE || !process.env.VUE_APP_JORNAYA_CAMPAIGN_CODE
    ) {
      // eslint-disable-next-line no-console
      console.log('[INFO] No VUE_APP_JORNAYA_ACCOUNT_CODE or VUE_APP_JORNAYA_CAMPAIGN_CODE found. Ignoring Journaya consent tracking');
      return null;
    }

    const callbackscript = document.createElement('script');
    callbackscript.type = 'text/javascript';
    callbackscript.innerHTML = 'function campaignLoadCallback() {console.log("[INFO] Jornaya campaign loaded")}';
    document.body.appendChild(callbackscript);

    const jScript = document.createElement('script');
    jScript.id = 'LeadiDscript_campaign';
    jScript.type = 'text/javascript';
    jScript.async = true;
    jScript.src = `//create.lidstatic.com/campaign/${process.env.VUE_APP_JORNAYA_CAMPAIGN_CODE}.js?snippet_version=2&callback=campaignLoadCallback`;
    document.body.appendChild(jScript);

    const imgScript = document.createElement('noscript');
    imgScript.innerHTML = `//create.leadid.com/noscript.gif?lac=${process.env.VUE_APP_JORNAYA_ACCOUNT_CODE}&lck=${process.env.VUE_APP_JORNAYA_CAMPAIGN_CODE}&snippet_version=2`;
    document.body.appendChild(imgScript);
  }

  readToken() {
    this.leadidToken = window?.LeadiD?.token;
    return this.leadidToken;
  }
}

export default Jornaya;
